import { SortOrderType } from '@supoui/shared/model/enumerations/sort-order-type.model';
import { CasesFilter } from './cases-filter.model';

export class CaseFilterRequest {
  sortBy: string;
  status: string;
  userId: string;
  teamId: string;
  pageIndex: number;
  pageSize: number;
  sortOrder: SortOrderType;
  filter: CasesFilter;

  public constructor(init?: Partial<CaseFilterRequest>) {
    Object.assign(this, init);
  }
}
